import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';
import { Router } from '@angular/router';
import { OpreatorModelModule } from './model/opreator-model.module';
import { FaqModule } from './model/faq.module';

@Component({
  selector: 'app-fqa',
  templateUrl: './fqa.component.html',
  styleUrls: ['./fqa.component.css']
})
export class FqaComponent implements OnInit {
  faqs: FaqModule;
  editEnable: boolean;
  Efaq: any;
  new_cat: boolean;
  new_faq: boolean;
  new_ques: string;
  new_answer: string;
  opraitorId: string= '';
  opraitorlang: string = 'en';


   // edite 2 way binding vars
  edit_ques: string;
  edit_answer: string;
  edit_opraitorId: string;
  edit_lang: string;

  editableCat: string;
  opraitors: any[];
  constructor( private games: GamesService, private router: Router ) { 

  }

  ngOnInit() {
    // this.getAllCats;
    this.games.getMygamesOpreators().subscribe(
      next => { this.opraitors = next['data'] as OpreatorModelModule[] }
      )

      this.games.getAllFaq().subscribe(next => { this.faqs = next as FaqModule })

}

selectQuzOpraitor(event: any) {
    this.opraitorId = event.target.value;
    this.edit_opraitorId = event.target.value;
  }
  selectLang(lang: string) {
    this.opraitorlang = lang;
  }

  editFaq(faq: any) {
      this.editEnable = true;
      console.log('faq', faq);
      this.Efaq = faq;
      console.log(this.Efaq );

      this.edit_ques = faq.question;
      this.edit_answer = faq.answer;
      this.edit_opraitorId = faq._p_operator_id;
      this.edit_lang = faq.lang;
    }

     // save changes in row ;
    save(id) {
      const form = new FormData();
      form.set('question', this.edit_ques);
      form.append('answer', this.edit_answer);
      form.append('operator_id', this.edit_opraitorId);
      form.append('lang',  this.edit_lang);
      console.log(form , "after int")

      this.games.updateFaq(id, form).subscribe(next => {
        console.log(next);
         this.editEnable = false; this.Efaq = '';
       // location.reload();
       console.log(form)
    },
     error => { console.log(error); });
    }

    deletaFaq(id){
      const conf = confirm('are you sure you whant delete this row ?');
      if (conf) {
        this.games.deletaFaq(id).subscribe(next => { console.log(next)
          alert("Done");
          window.location.reload()
        } );
    } }

    newFaq(){
      let form = new FormData();
      form.append('question', this.new_ques);
      form.append('answer', this.new_answer);
      form.append('operator_id', this.opraitorId);
      form.append('lang', this.opraitorlang);

       this.games.NewFaq(form).subscribe(next => {
          console.log(next);
          location.reload();
        } )
        

      // , error => { console.log(error) });



  /**
   * get all
   *@description get all cats from backend 
   */

  // getAllCats(){
  //   this.games.getAllCats().subscribe(next=>{
  //     this.cats=next['cat_lists'];
  //     console.log(next['cat_lists']);
  //   },error=>{console.log(error)});
  // }

    }
  }


// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/fqa/fqa.component.ts